import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TutorService } from '../tutor.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CONSTANTS } from '../../../../core/constants';
import { GlobalFunctions } from '../../../../core/global-functions';
import { CommonService } from '../../../../core/common.service';

@Component({
  selector: 'app-rate-per-hour',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, ReactiveFormsModule, ToastModule],
  templateUrl: './rate-per-hour.component.html',
  styleUrl: './rate-per-hour.component.scss'
})
export class RatePerHourComponent implements OnInit {

  constants: any = CONSTANTS;
  rateForm: FormGroup;
  profileDetails: any;
  isBtnLoading: boolean = false;

  constructor(
    private _tutorServices: TutorService,
    private _globalFunctions: GlobalFunctions,
    private messageService: MessageService,
    private _router: Router,
    private _commonService: CommonService,
    private _formBuilder: FormBuilder
  ) {
    this.rateForm = this._formBuilder.group({
      rate: [0, [Validators.required, Validators.min(1), Validators.pattern("^[0-9]*$")]],
    });
  }

  ngOnInit(): void {
    this.getUserDetails();
  }

  goBack() {
    this._router.navigate(['/tutor-signup/' + this.constants.tutorAvailibilityUrl]);
  }

  getUserDetails() {
    this._commonService.getProfile(false, true).subscribe({
      next: (result: any) => {
        if (result && result.success && result.data) {
          this.profileDetails = result.data;
          this._commonService.setProfileData(result.data); // Update local storage
          this.rateForm.patchValue({ rate: result.data?.hourly_rate });
        }
      },
      error: (error: any) => {
        const errorMsg = error?.error?.message || error?.message || 'Failed to load profile details.';
        this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
      }
    });
  }

  updateRate() {
    if (this.rateForm.invalid) {
      this.rateForm.markAllAsTouched();
      return;
    }

    // Optimization: If no changes, just navigate to the next step
    if (!this.rateForm.dirty) {
      this._router.navigate(['/tutor-signup/' + this.constants.tutorSubmitUrl]);
      return;
    }

    this.isBtnLoading = true;
    this._tutorServices.updateRate({ hourly_rate: this.rateForm.value.rate }).subscribe({
      next: (result: any) => {
        if (result && result?.success) {
          this.isBtnLoading = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: result.message });
          this._commonService.getProfile(false, true).subscribe({
            next: (profileResult: any) => {
              if (profileResult && profileResult?.success) {
                this._commonService.setProfileData(profileResult?.data);
                this._router.navigate(['/tutor-signup/' + this.constants.tutorSubmitUrl]);
              } else {
                const errorMsg = profileResult?.message || 'Failed to fetch updated profile.';
                this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
              }
            },
            error: (error: any) => {
              const errorMsg = error?.error?.message || error?.message || 'Failed to fetch updated profile.';
              this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
            }
          });
        } else {
          this.isBtnLoading = false;
          const errorMsg = result?.message || 'Failed to update rate.';
          this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
        }
      },
      error: (error: any) => {
        this.isBtnLoading = false;
        const errorMsg = error?.error?.message || error?.message || 'Something went wrong while updating rate.';
        this.messageService.add({ severity: 'error', summary: 'Oops..!', detail: errorMsg });
      }
    });
  }
}